/**
 * Client Context - React Context 定义与消费 Hooks
 *
 * 运行时层在根组件中注入以下 Context，使所有模块的组件都能访问全局注册的资源。
 */
import { createContext, useContext } from 'react';
/** 组件注册表 Context */
export const ClientComponentsContext = createContext({});
/** 全局状态 Context */
export const ClientGlobalStateContext = createContext({});
/** 服务注册表 Context */
export const ClientServicesContext = createContext({});
/** Hooks 注册表 Context */
export const ClientHooksContext = createContext({});
/* -------------------------------------------------------------------------- */
/* 消费 Hooks                                                                  */
/* -------------------------------------------------------------------------- */
/**
 * 通过 serviceTag 获取已注册的业务服务实例
 *
 * 必须在 ClientServicesContext.Provider 包裹的组件树内使用。
 *
 * @param serviceTag 服务注册时的 tag，如 'pwaLinksApiClient'
 * @returns 服务实例（需调用方自行断言类型）
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const apiClient = useClientServiceByTag<IPwaLinksApiClient>('pwaLinksApiClient')
 *   // ...
 * }
 * ```
 */
export function useClientServiceByTag(serviceTag) {
    const services = useContext(ClientServicesContext);
    return services[serviceTag];
}
//# sourceMappingURL=context.js.map